import { useEffect } from "react";

import { useRootDispatch, useRootSelector } from "@ds/hooks";

import { selectExperienceById } from "@ds/modules/experiences/redux/selectors";
import { experiencesActions } from "@ds/modules/experiences/redux/slice";
import { isIncompleteExperience } from "@ds/modules/experiences/utils/model";

/** The experience of a single selected player when it is incomplete; multiple selected players are not checked */
export const useIncompletePlayerExperience = (players: Player[]): Experience | undefined => {
  const experienceId = players.length === 1 ? players[0].experience_id : undefined;
  const experience = useRootSelector(state => (experienceId ? selectExperienceById(state, experienceId) : undefined));

  const dispatch = useRootDispatch();
  useEffect(() => {
    if (experienceId) {
      dispatch(experiencesActions.fetchExperience(experienceId));
    }
  }, [dispatch, experienceId]);

  return experience && isIncompleteExperience(experience) ? experience : undefined;
};
